import { render } from "./DataRetentionSection.vue?vue&type=template&id=667e97dc"
import script from "./DataRetentionSection.vue?vue&type=script&lang=js"
export * from "./DataRetentionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__